import React from "react";

const CardEl = ({ title, children }) => {
  return (
    <div className="card my-3 ">
      <div className="card-body">
        <div className="h3 mb-3">{title}</div>
        <div>{children}</div>
      </div>
    </div>
  );
};

export default CardEl;
